import React from "react";
import { ThemeProvider, theme } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import InterestFormImageSvg from "../../Icons/InterestFormImageSvg";

const newTheme = {
  ...theme,
  variants: {},
};

export default function InterestModalComponent(props: any) {
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div className="absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900">
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className="relative border-b bg-gray-50">
            <div className="w-full absolute bottom-0 xl:inset-0 xl:h-full hidden xl:block">
              <div className="h-full w-full xl:grid xl:grid-cols-2">
                <div className="h-full xl:relative xl:col-start-2 flex items-end mx-auto">
                  <InterestFormImageSvg />
                </div>
              </div>
            </div>
            <div className="px-4 lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8">
              <div className="relative py-6 text-left lg:py-10">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
                <div className="mt-2 text-base text-gray-500">
                  {props.subHeading}
                </div>
              </div>
            </div>
          </div>
          <div className="text-left max-w-full">
            <div className="mt-2 text-base text-gray-500">
              {props.description}
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
